import clsx from 'clsx'
import { FC } from 'react'

import CallMe from '@/screensComponents/FinancialServices/CallMe/CallMe'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'

import { data } from './data'

import cl from './index.module.scss'

export const ExchangeAndReturns: FC = () => (
	<div className={cl.exchangeAndReturns}>
		<div className={cl.exchangeAndReturns__textWrapper}>
			<h1 className={cl.exchangeAndReturns__title}>{data.title}</h1>
			<p className={cl.exchangeAndReturns__subtitle}>{data.subtitle}</p>
		</div>
		<div className={cl.exchangeAndReturns__descriptionContainer}>
			{data.conditions.map((item, index) => (
				<section className={cl.exchangeAndReturns__item} key={index}>
					<h2 className={cl.exchangeAndReturns__itemTitle}>{item.title}</h2>
					<div
						className={cl.exchangeAndReturns__itemSubtitle}
						dangerouslySetInnerHTML={createMarkup(item.description)}
					/>
					{item.noteText && (
						<p className={clsx(cl.exchangeAndReturns__itemSubtitle, cl.exchangeAndReturns__itemSubtitle_notation)}>
							{item.noteText}
						</p>
					)}
				</section>
			))}
		</div>
		<div className={cl.exchangeAndReturns__notationContainer}>
			<p className={cl.exchangeAndReturns__notationText}>
				Возврат переведённых средств, производится на ваш банковский счёт в течение 5–30 рабочих дней (срок зависит от
				банка, который выдал банковскую карту). Для обмена или возврата товара вы можете обратиться с чеком и
				устройством в магазин, в котором совершалась покупка.
			</p>
			<CallMe body={'Вы можете получить консультацию по обмену или возврату товара позвонив по номеру'} />
		</div>
	</div>
)
